import { Button } from "@mui/material";
import { Loader } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import NoItemUI from "src/Components/NoItemUI";
import clsx from "clsx";

interface IProps {
  children: React.ReactNode;
  isLoading: boolean;
  length: number;
  currentPage: number;
  totalPages: number;
  onLoadMore: (page: number) => void;
  className?: string;
  isLoadButton?: boolean;
  noDataOptions?: {
    text?: string;
    text2?: string;
    buttonText?: string;
    buttonOnPress?: () => void;
    iconImagePath?: string;
  };
  renderSkeleton?: () => React.ReactNode;
  checkMore?: boolean;
  calculateHeight?: boolean;
  itemClassName?: string;
  paddingBottom?: string;
}

const InfinteScrollWrapper = ({
  children,
  isLoading,
  length,
  currentPage,
  totalPages,
  onLoadMore,
  className,
  isLoadButton = false,
  noDataOptions,
  renderSkeleton,
  checkMore = true,
  calculateHeight = false,
  itemClassName = ".tab-slider-container-main",
  paddingBottom = "pb-[50px]",
}: IProps) => {

  const ref = useRef<HTMLDivElement>(null);
  const [minHeight, setMinHeight] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (calculateHeight) {
      let ele : any = document.querySelector(itemClassName || "");
      if (ele) {
        let height = ele?.clientHeight;
        let top = ele.offsetTop;
        let minHeight = window.innerHeight - top - height - 120;
        console.log(minHeight , "======> Min Height");
        setMinHeight(minHeight);
      }else{
        setMinHeight(100);
      }
    }else{
      setMinHeight(undefined);
    }
  }, [calculateHeight]);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        onLoadMore(currentPage + 1);
      }
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [onLoadMore, currentPage, totalPages, isLoading]);

  return (
    <div
      className={clsx(
        "w-full flex flex-col gap-2 2xl:gap-4",
        className,
        paddingBottom
      )}
    >
      {children}

      {isLoading && !renderSkeleton && (
        <div className="w-full h-10 flex items-center gap-2 justify-center py-5 2xl:py-7">
          <Loader className="2xl:w-5 2xl:h-5 w-4 h-4 animate-spin" />
          <p className="font-Poppins-Regular font-size-14px">Loading...</p>
        </div>
      )}

      {isLoading && renderSkeleton && renderSkeleton()}

      {!isLoading && length === 0 && (
        // <div className="py-5 2xl:py-7">
          <NoItemUI
            text={noDataOptions?.text}
            text2={noDataOptions?.text2}
            iconImagePath={noDataOptions?.iconImagePath}
            onButtonClick={() => {
              noDataOptions?.buttonOnPress?.();
            }}
            minHeight={minHeight}
            ButtonText={noDataOptions?.buttonText}
          />
        // </div>
      )}

      {!isLoading && currentPage < totalPages && !isLoadButton && checkMore && (
        <div
          className="w-full h-10 flex items-center justify-center"
          ref={ref}
        ></div>
      )}

      {!isLoading && currentPage < totalPages && isLoadButton && checkMore && (
        <div className="w-full py-2 2xl:py-4 flex items-center justify-center" ref={ref}>
          <Button
            onClick={() => onLoadMore(currentPage + 1)}
          >
            Load More
          </Button>
        </div>
      )}
    </div>
  );
};

export default InfinteScrollWrapper;
